module.exports = __webpack_public_path__ + "media/images/icon_tab2_on-b325ce145a709f651f5eced0c8cadf71.png";